
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0178a11d\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./wervendetail.vue")
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0178a11d\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector?type=styles&index=1!./wervendetail.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./wervendetail.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0178a11d\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./wervendetail.vue"),
  /* scopeId */
  "data-v-0178a11d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/wervendetail.vue
// module id = 40
// module chunks = 3